export default __webpack_public_path__ + "static/Element_Shard-6bab768d7db49168721c730939d2707a.png";